import { render, staticRenderFns } from "./yego_dashboard.vue?vue&type=template&id=67d19a42"
import script from "./yego_dashboard.vue?vue&type=script&lang=js"
export * from "./yego_dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports